import React from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@vtex/admin-ui'

import { useFormatCurrency } from '../../../Checkout/hooks'

export type DeliveryAvailabilityPriceProps = {
  price: number
}

export const DeliveryAvailabilityPrice = ({
  price,
}: DeliveryAvailabilityPriceProps) => {
  const formatCurrency = useFormatCurrency()
  const { formatMessage } = useIntl()
  const value = price / 100

  return (
    <Text variant="action1" tone={price === 0 ? 'positive' : 'primary'}>
      {value === 0
        ? formatMessage({ id: 'freeShipping' })
        : formatCurrency(value)}
    </Text>
  )
}
